<!-- <div class="container-fluid"> -->
    <div class="wrapper">
        <div class="formwrap py-5">
          <div class="titlewrap container">
            <h1 class="title">Forgot Password??</h1>
            <h1 class="title"><a [routerLink]="setpasswordforstudent?'':['/boardadminlogin']"><i class="bi bi-house-fill" style="color:black;"></i></a></h1>
          </div>
        <form *ngIf="setpasswordforstudent" method="post" role="form" name="form1" #form="ngForm" [formGroup]="Registerform" (ngSubmit)="resetpassword(Registerform.value)">
    
          <div class="row" style="padding: 0px; margin: 0px;">
          <div class="card p-5 mt-3 effect1 col-md-6 mx-auto">
                  
        <div class="row mb-3">
                <div class="col-md-12">
                <label class="control-label">Standard<span class="strip">*</span></label>
                <select formControlName="standard"  name="standard" id="standard"class=" form-select"
                    [ngClass]="{ 'is-invalid': submitted1 && f.standard.errors }">
                    <option value="SSC">SSC</option>
                    <option value="HSSC">HSSC</option>         
                </select>
                <div *ngIf="submitted && f.standard.errors" class="invalid-feedback">
                    <div *ngIf="f.standard.errors.required">Stadard is required</div>
                </div>
                </div>
        </div>
        <div class="row mb-3">       
        <div class="col-md-12">
          <label class="control-label">Application Type<span class="strip">*</span></label>
          <select formControlName="application_type"  name="application_type" id="application_type" class="form-select" 
            [ngClass]="{ 'is-invalid': submitted && f.application_type.errors }">
            <option *ngFor="let fees of allfeesdata" [value]="fees.application_type">{{fees.application_type_name}}</option>
          </select>
            <div *ngIf="submitted && f.application_type.errors" class="invalid-feedback">
              <div *ngIf="f.application_type.errors.required">Application type is required</div>
                </div>
        </div>
        </div>
        <div class="row mb-3">
        
      
        <div class="col-md-12">
          <label class="control-label">Email Id<span class="strip">*</span></label>
            <input type="email" formControlName="email_address" name="email_address" id="email_address" class="form-control" value=""
            [ngClass]="{ 'is-invalid': submitted && f.email_address.errors }"/>
            <div *ngIf="submitted && f.email_address.errors" class="invalid-feedback">
              <div *ngIf="f.email_address.errors.required">Email address is required</div>
            </div>
          </div>
        </div>
        <div class="row"> 
            <div class="d-grid gap-2 d-md-flex justify-content-center mt-3" >
              <!-- <button class="btn btn-danger me-md-2" type="button"  data-bs-toggle="modal" data-bs-target="#exampleModal">Register</button>-->
    
                <button class="btn btn-success me-md-2" type="submit">Send New Password</button>
            </div>
        </div> 
            </div>
        </div>
        </form>
        <!-- boardadmin reset -->
        <form *ngIf="!setpasswordforstudent" method="post" role="form" name="form1" #form="ngForm" [formGroup]="Registerform1" (ngSubmit)="resetpassword(Registerform1.value)">
    
          <div class="row" style="padding: 0px; margin: 0px;">
          <div class="card p-5 mt-3 effect1 col-md-6 mx-auto">                
        <div class="row mb-3">        
      
        <div class="col-md-12">
          <label class="control-label">Email Id<span class="strip">*</span></label>
            <input type="email" formControlName="email_address" name="email_address" id="email_address" class="form-control" value=""
            [ngClass]="{ 'is-invalid': submitted && b.email_address.errors }"/>
            <div *ngIf="submitted && b.email_address.errors" class="invalid-feedback">
              <div *ngIf="b.email_address.errors.required">Email address is required</div>
            </div>
          </div>
        </div>
        <div class="row"> 
            <div class="d-grid gap-2 d-md-flex justify-content-center mt-3" >
              <!-- <button class="btn btn-danger me-md-2" type="button"  data-bs-toggle="modal" data-bs-target="#exampleModal">Register</button>-->
    
                <button class="btn btn-success me-md-2" type="submit">Send New Password</button>
            </div>
        </div> 
            </div>
        </div>
        </form>
      </div>
    
    <!----modal for Varify OTP-->
    <!-- <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog" style="width: 350px;">
        <div class="modal-content">
          <div class="modal-header">
              <h6>Enter OTP Number</h6>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
              <form method="POST">
                  <div class="form-group mb-3">
                   <label>Enter OTP Number</label>
                   <input type="text" name="user_otp" class="form-control" />
                  </div>
                  <div class="form-group">
                      <div class="row">
                          <div class="col-md-5">
                            <div class="form-group">
                                <input type="submit" name="submit" class="btn btn-success px-4"  value="Verify OTP" [routerLink]="['/Login']" (click)="verify()" data-bs-dismiss="modal" aria-label="Close" />
                               </div>
                        </div>
                        <div class="col-md-2"></div>
                        <div class="col-md-5">
                            <div class="form-group">
                                <input type="submit" name="submit" class="btn btn-primary px-3" value="Resend OTP" />
                               </div>
                        </div>
                        </div>
                  </div>
              </form>
          </div>
          </div>
          </div>
          </div> -->
          <div *ngIf="proccessing" class="loadingcont">
            <div class="spinner"></div>
          </div>
        </div>
    <!-- </div> -->